import {
  get_rawSession1kjo1nj4tz6n0 as get_rawSession,
  get_session9cytjmfbg8nd as get_session,
} from '../../../sdk/UserSession.mjs';
import {
  await1kke5zj2piplv as await_0,
  awaitOnce2ui7qqi9bvdeq as awaitOnce,
  awaitqeg6zusi9ora as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import {
  resolveProjectAttachments1r3ylk2p3xmwv as resolveProjectAttachments,
  RemoteAttachment3uyi4s0lht7h0 as RemoteAttachment,
  LocalFileyitm5ua4ch17 as LocalFile,
} from '../files/attachmentFilePreview.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { toFileData1whrjalotozwt as toFileData } from '../../../extensions/ProjectAttachment.ext.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  _ServerFile___get_location__impl__ddyqaq3o0wsfuapqiy2 as _ServerFile___get_location__impl__ddyqaq,
  _ServerFile___init__impl__jj3mn23p0pea18kbfe7 as _ServerFile___init__impl__jj3mn2,
  ServerFile1t91jzpzoixwe as ServerFile,
} from '../../../../../../lightning-server-shared/com/lightningkite/lightningserver/files/ServerFile.mjs';
import {
  substringBeforekje8w2lxhyb6 as substringBefore,
  substringBefore3n7kj60w69hju as substringBefore_0,
  trim6jpmwojjgb3l as trim,
  isBlank1dvkhjjvox3p0 as isBlank,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { modify2eca96i8s7hc2 as modify } from '../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { pushChanges1lnw8bjwewvzf as pushChanges } from '../../../utils/Draft.ext.mjs';
import { Specification3fgfbf7ihgj8v as Specification } from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  get_dialogStackleaqvayyucjw as get_dialogStack,
  get_viewIsNarrow26l63sh4olw2h as get_viewIsNarrow,
  get_viewIsWide3s4g60a9e0192 as get_viewIsWide,
} from '../nav/crowpay.mjs';
import { charArrayOf27f4r3dozbrk1 as charArrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import {
  DangerButtonSemantic_getInstanceb7gofax87736 as DangerButtonSemantic_getInstance,
  get_expandButtonTheme1dpdnzsv2lxs8 as get_expandButtonTheme,
  get_deleteButton1v46c8rhktdg5 as get_deleteButton,
  get_textButtonybbt8y3eu5hx as get_textButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
} from '../../theming/buttons.mjs';
import { GenericConfirmationDialog172k63mmx5r2d as GenericConfirmationDialog } from '../../dialogs/GenericConfirmationDialog.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { Draft43syxm8fng0j as Draft } from '../../../../../../reactive/com/lightningkite/reactive/core/Draft.mjs';
import { validated2q9ie09qg9r46 as validated } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/ValidatedDraft.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { debounce3uffs71hj1o26 as debounce } from '../../../../../../reactive/com/lightningkite/reactive/extensions/debounce.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { SpecificationItemForm2u6jawyk2khsg as SpecificationItemForm } from './SpecificationItemForm.mjs';
import {
  Action1a4ymn5nx79hk as Action,
  truncate3gvhc1a2is66m as truncate,
  shownDefaultFalse3hpz4awymyomc as shownDefaultFalse,
} from '../../../utils/utils.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { WithoutPadding_instance322j5y2aaszpe as WithoutPadding_instance } from '../../theming/sections.mjs';
import {
  dynamicThemexp3sdnaolntz as dynamicTheme,
  get_italic11nskfy97pz2f as get_italic,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_centered1xfu6or5nc0lq as get_centered,
  get_atEnd1cw5d2zgug26 as get_atEnd,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  get_unpadded3gipn3ftxgnwh as get_unpadded,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import {
  expandIcon1as9er6lyg7in as expandIcon,
  expandAction2iatt63opw8h9 as expandAction,
} from '../expansion.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
} from '../../theming/Titles.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue__compareTo_impl_w7ul1r2xnp6r3vvhd1h as MonetaryValue__compareTo_impl_w7ul1r,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
} from '../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import {
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance_0,
  Dimensions32ju1l7z4mh as Dimension,
  Align_End_getInstance1wccjuzcldlk8 as Align_End_getInstance,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { get_trash3qsdn4kaynjmu as get_trash } from '../../../icons.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  shownWhenxgf1ujy6rmvr as shownWhen,
  align1ejncrrer3meh as align,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  Indent_CenteredSection_getInstance372tfy97032sl as Indent_CenteredSection_getInstance,
  indented3383b46h9g40w as indented,
} from '../space.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { render38qn7o0b2bza2 as render } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Routes.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../nav/AppDimensions.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$Action, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_rawSession();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_elvis_lhs = tmp;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var session = tmp_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.ii2_1.ci2_1;
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$1 = tmp_1;
  var tmp_2 = $this.ii2_1.yi1_1(tmp$ret$1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  if ($this.ii2_1.bi2_1.f2()) {
    var tmp_3;
    var tmp_4 = $this.ii2_1.di2_1.f2().p1();
    var tmp_5 = awaitOnce($this.ii2_1.ci2_1, $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    if (!(tmp_4 === tmp_5.z83_1.p1())) {
      tmp_3 = true;
    } else {
      var tmp0 = $this.ii2_1.di2_1.f2();
      var tmp$ret$2;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_6;
        if (isInterface(tmp0, Collection())) {
          tmp_6 = tmp0.i1();
        } else {
          tmp_6 = false;
        }
        if (tmp_6) {
          tmp$ret$2 = false;
          break $l$block_0;
        }
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          var tmp_7;
          var tmp_8 = element.cgc_1;
          if (tmp_8 instanceof LocalFile()) {
            tmp_7 = true;
          } else {
            var tmp_9 = element.bgc_1.f2();
            var tmp_10 = element.dgc_1;
            var tmp0_safe_receiver = tmp_10 instanceof RemoteAttachment() ? tmp_10 : null;
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ugb_1;
            tmp_7 = !(tmp_9 === (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.i20()));
          }
          if (tmp_7) {
            tmp$ret$2 = true;
            break $l$block_0;
          }
        }
        tmp$ret$2 = false;
      }
      tmp_3 = tmp$ret$2;
    }
    var filesChanged = tmp_3;
    var tmp_11;
    var tmp_12 = awaitOnce($this.ii2_1.ci2_1.cak(), $completion);
    if (tmp_12 === get_COROUTINE_SUSPENDED())
      tmp_12 = yield tmp_12;
    if (!tmp_12) {
      tmp_11 = !filesChanged;
    } else {
      tmp_11 = false;
    }
    if (tmp_11)
      return Unit_instance;
    var tmp_13 = awaitOnce($this.ii2_1.ci2_1, $completion);
    if (tmp_13 === get_COROUTINE_SUSPENDED())
      tmp_13 = yield tmp_13;
    var current = tmp_13;
    var tmp_14 = awaitOnce($this.ii2_1.di2_1, $completion);
    if (tmp_14 === get_COROUTINE_SUSPENDED())
      tmp_14 = yield tmp_14;
    var tmp_15 = resolveProjectAttachments(tmp_14, $completion);
    if (tmp_15 === get_COROUTINE_SUSPENDED())
      tmp_15 = yield tmp_15;
    var newFiles = tmp_15;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().u(collectionSizeOrDefault(newFiles, 10));
    var _iterator__ex2g4s_0 = newFiles.m1();
    while (_iterator__ex2g4s_0.n1()) {
      var item = _iterator__ex2g4s_0.o1();
      var tmp_16 = _ServerFile___init__impl__jj3mn2(substringBefore(_ServerFile___get_location__impl__ddyqaq(item.u79_1), '?'));
      var tmp0_safe_receiver_0 = item.v79_1;
      var tmp_17;
      var tmp_18 = tmp0_safe_receiver_0;
      if ((tmp_18 == null ? null : new (ServerFile())(tmp_18)) == null) {
        tmp_17 = null;
      } else {
        var tmp_19 = tmp0_safe_receiver_0;
        // Inline function 'kotlin.let' call
        var it = (tmp_19 == null ? null : new (ServerFile())(tmp_19)).l2n_1;
        tmp_17 = _ServerFile___init__impl__jj3mn2(substringBefore(_ServerFile___get_location__impl__ddyqaq(it), '?'));
      }
      var tmp$ret$6 = item.x79(VOID, VOID, tmp_16, tmp_17);
      destination.v(tmp$ret$6);
    }
    var newFilesSimplified = destination;
    // Inline function 'kotlin.collections.map' call
    var this_2 = current.z83_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList().u(collectionSizeOrDefault(this_2, 10));
    var _iterator__ex2g4s_1 = this_2.m1();
    while (_iterator__ex2g4s_1.n1()) {
      var item_0 = _iterator__ex2g4s_1.o1();
      var tmp_20 = _ServerFile___init__impl__jj3mn2(substringBefore_0(_ServerFile___get_location__impl__ddyqaq(item_0.u79_1), _Char___init__impl__6a9atx(63)));
      var tmp0_safe_receiver_1 = item_0.v79_1;
      var tmp_21;
      var tmp_22 = tmp0_safe_receiver_1;
      if ((tmp_22 == null ? null : new (ServerFile())(tmp_22)) == null) {
        tmp_21 = null;
      } else {
        var tmp_23 = tmp0_safe_receiver_1;
        // Inline function 'kotlin.let' call
        var it_0 = (tmp_23 == null ? null : new (ServerFile())(tmp_23)).l2n_1;
        tmp_21 = _ServerFile___init__impl__jj3mn2(substringBefore_0(_ServerFile___get_location__impl__ddyqaq(it_0), _Char___init__impl__6a9atx(63)));
      }
      var tmp$ret$11 = item_0.x79(VOID, VOID, tmp_20, tmp_21);
      destination_0.v(tmp$ret$11);
    }
    var oldFiles = destination_0;
    if (!equals(oldFiles, newFilesSimplified)) {
      var tmp_24 = modify($this.ii2_1.ci2_1, EditSpecificationItem$save$slambda$slambda_0(newFiles), $completion);
      if (tmp_24 === get_COROUTINE_SUSPENDED())
        tmp_24 = yield tmp_24;
    }
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_3 = get_session();
    var tmp_25 = await_0(this_3, $completion);
    if (tmp_25 === get_COROUTINE_SUSPENDED())
      tmp_25 = yield tmp_25;
    var tmp$ret$14 = tmp_25;
    var tmp_26 = pushChanges($this.ii2_1.ci2_1, tmp$ret$14.qfv_1, $completion);
    if (tmp_26 === get_COROUTINE_SUSPENDED())
      tmp_26 = yield tmp_26;
    var result = tmp_26;
    var tmp_27 = $this.ii2_1.di2_1.iah(toFileData(result.z83_1), $completion);
    if (tmp_27 === get_COROUTINE_SUSPENDED())
      tmp_27 = yield tmp_27;
  } else {
    println('Inserting Specification');
    var tmp_28 = awaitOnce($this.ii2_1.ci2_1, $completion);
    if (tmp_28 === get_COROUTINE_SUSPENDED())
      tmp_28 = yield tmp_28;
    var current_0 = tmp_28;
    var tmp_29 = awaitOnce($this.ii2_1.di2_1, $completion);
    if (tmp_29 === get_COROUTINE_SUSPENDED())
      tmp_29 = yield tmp_29;
    var tmp_30 = resolveProjectAttachments(tmp_29, $completion);
    if (tmp_30 === get_COROUTINE_SUSPENDED())
      tmp_30 = yield tmp_30;
    var newFiles_0 = tmp_30;
    var tmp_31 = session.qfv_1.eek(current_0.c84(VOID, VOID, VOID, VOID, VOID, VOID, VOID, newFiles_0), $completion);
    if (tmp_31 === get_COROUTINE_SUSPENDED())
      tmp_31 = yield tmp_31;
    var tmp_32 = await_0(tmp_31, $completion);
    if (tmp_32 === get_COROUTINE_SUSPENDED())
      tmp_32 = yield tmp_32;
    var result_0 = ensureNotNull(tmp_32);
    var tmp_33 = $this.ii2_1.ci2_1.aak().iah(result_0, $completion);
    if (tmp_33 === get_COROUTINE_SUSPENDED())
      tmp_33 = yield tmp_33;
    $this.ii2_1.ci2_1.nai();
    var tmp_34 = $this.ii2_1.di2_1.iah(toFileData(result_0.z83_1), $completion);
    if (tmp_34 === get_COROUTINE_SUSPENDED())
      tmp_34 = yield tmp_34;
    var tmp_35 = $this.ii2_1.bi2_1.iah(true, $completion);
    if (tmp_35 === get_COROUTINE_SUSPENDED())
      tmp_35 = yield tmp_35;
  }
  var tmp_36 = $this.ii2_1.ei2_1.iah(false, $completion);
  if (tmp_36 === get_COROUTINE_SUSPENDED())
    tmp_36 = yield tmp_36;
  return Unit_instance;
}
var EditSpecificationItem$save$slambda$slambdaClass;
function EditSpecificationItem$save$slambda$slambda() {
  if (EditSpecificationItem$save$slambda$slambdaClass === VOID) {
    class $ {
      constructor($newFiles) {
        this.ji2_1 = $newFiles;
      }
      ki2(it, $completion) {
        return it.c84(VOID, VOID, VOID, VOID, VOID, VOID, VOID, this.ji2_1);
      }
      s2(p1, $completion) {
        return this.ki2(p1 instanceof Specification() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EditSpecificationItem$save$slambda$slambdaClass = $;
  }
  return EditSpecificationItem$save$slambda$slambdaClass;
}
function EditSpecificationItem$save$slambda$slambda_0($newFiles) {
  var i = new (EditSpecificationItem$save$slambda$slambda())($newFiles);
  var l = (it, $completion) => i.ki2(it, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_0($this, confirmed, $completion) {
  if (confirmed) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $this.li2_1.ci2_1;
    var tmp = await_0(this_0, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var id = tmp.s83_1;
    var tmp_0 = await_1($this.li2_1.bi2_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    if (tmp_0) {
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_1 = get_session();
      var tmp_1 = await_0(this_1, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      var tmp_2 = tmp_1.vfw().zfg_1.zfh(id, $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
    }
    var tmp_3 = $this.li2_1.xi1_1($this.mi2_1, id, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = $this.ni2_1.vhn($this.oi2_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  var tmp = await_1($this.pi2_1.bi2_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (tmp) {
    $this.pi2_1.ci2_1.nai();
    var tmp_0 = awaitOnce($this.pi2_1.ci2_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var tmp_1 = $this.pi2_1.di2_1.iah(toFileData(tmp_0.z83_1), $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var tmp_2 = $this.pi2_1.ei2_1.iah(false, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
  } else {
    var tmp_3 = $this.pi2_1.vhn($this.qi2_1, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  }
  return Unit_instance;
}
function *_generator_remove__l4h01w($this, _this__u8e3s4, $completion) {
  var tmp;
  var tmp_0 = await_1($this.bi2_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  if (tmp_0) {
    tmp = to('Delete Specification?', 'Deleting a specification cannot be undone. Are you sure you want to delete this Specification?');
  } else {
    tmp = to('Discard Specification?', 'Discarding unsaved work cannot be undone. Are you sure you want to discard this unsaved Specification?');
  }
  var _destruct__k2r9zo = tmp;
  var header = _destruct__k2r9zo.cf();
  var removeMessage = _destruct__k2r9zo.df();
  var tmp_1 = get_dialogStack();
  var tmp_2 = trim(header, charArrayOf([_Char___init__impl__6a9atx(63)]));
  var tmp_3 = DangerButtonSemantic_getInstance();
  tmp_1.zgd(new (GenericConfirmationDialog())(header, removeMessage, null, tmp_2, 'Go Back', tmp_3, VOID, VOID, VOID, VOID, EditSpecificationItem$remove$slambda_0($this, _this__u8e3s4)));
  return Unit_instance;
}
var EditSpecificationItem$_init_$slambda_1ephs0Class;
function EditSpecificationItem$_init_$slambda_1ephs0() {
  if (EditSpecificationItem$_init_$slambda_1ephs0Class === VOID) {
    class $ {
      ki2(it, $completion) {
        return Unit_instance;
      }
      s2(p1, $completion) {
        return this.ki2(p1 instanceof Specification() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EditSpecificationItem$_init_$slambda_1ephs0Class = $;
  }
  return EditSpecificationItem$_init_$slambda_1ephs0Class;
}
function EditSpecificationItem$_init_$slambda_1ephs0_0() {
  var i = new (EditSpecificationItem$_init_$slambda_1ephs0())();
  var l = (it, $completion) => i.ki2(it, $completion);
  l.$arity = 1;
  return l;
}
var EditSpecificationItem$save$slambdaClass;
function EditSpecificationItem$save$slambda() {
  if (EditSpecificationItem$save$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.ii2_1 = this$0;
      }
      yah($this$Action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$Action), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EditSpecificationItem$save$slambdaClass = $;
  }
  return EditSpecificationItem$save$slambdaClass;
}
function EditSpecificationItem$save$slambda_0(this$0) {
  var i = new (EditSpecificationItem$save$slambda())(this$0);
  var l = ($this$Action, $completion) => i.yah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
var EditSpecificationItem$remove$slambdaClass;
function EditSpecificationItem$remove$slambda() {
  if (EditSpecificationItem$remove$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $this_remove) {
        this.li2_1 = this$0;
        this.mi2_1 = $this_remove;
      }
      egk(confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, confirmed), $completion);
      }
      s2(p1, $completion) {
        return this.egk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EditSpecificationItem$remove$slambdaClass = $;
  }
  return EditSpecificationItem$remove$slambdaClass;
}
function EditSpecificationItem$remove$slambda_0(this$0, $this_remove) {
  var i = new (EditSpecificationItem$remove$slambda())(this$0, $this_remove);
  var l = (confirmed, $completion) => i.egk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function Button$_get_visible_$ref_mav0jg(p0) {
  return () => p0.ab9();
}
function Button$_set_visible_$ref_7zj5sg(p0) {
  return (_this__u8e3s4) => {
    p0.zb8(_this__u8e3s4);
    return Unit_instance;
  };
}
var EditSpecificationItem$render$slambdaClass;
function EditSpecificationItem$render$slambda() {
  if (EditSpecificationItem$render$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.ni2_1 = this$0;
        this.oi2_1 = $$this$button;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditSpecificationItem$render$slambdaClass = $;
  }
  return EditSpecificationItem$render$slambdaClass;
}
function EditSpecificationItem$render$slambda_0(this$0, $$this$button) {
  var i = new (EditSpecificationItem$render$slambda())(this$0, $$this$button);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var EditSpecificationItem$render$slambdaClass_0;
function EditSpecificationItem$render$slambda_1() {
  if (EditSpecificationItem$render$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.pi2_1 = this$0;
        this.qi2_1 = $$this$button;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditSpecificationItem$render$slambdaClass_0 = $;
  }
  return EditSpecificationItem$render$slambdaClass_0;
}
function EditSpecificationItem$render$slambda_2(this$0, $$this$button) {
  var i = new (EditSpecificationItem$render$slambda_1())(this$0, $$this$button);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var EditSpecificationItemClass;
function EditSpecificationItem() {
  if (EditSpecificationItemClass === VOID) {
    class $ {
      constructor(ogSpec, contractorId, onRemove, onSave) {
        var tmp;
        if (onSave === VOID) {
          tmp = EditSpecificationItem$_init_$slambda_1ephs0_0();
        } else {
          tmp = onSave;
        }
        onSave = tmp;
        this.xi1_1 = onRemove;
        this.yi1_1 = onSave;
        var tmp_0 = this;
        tmp_0.zi1_1 = ogSpec == null ? new (Specification())(VOID, contractorId) : ogSpec;
        this.ai2_1 = this.zi1_1.s83_1;
        this.bi2_1 = Signal().hak(!(ogSpec == null));
        this.ci2_1 = validated(Draft(this.zi1_1));
        var tmp_1 = this;
        var tmp1_safe_receiver = ogSpec == null ? null : ogSpec.z83_1;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : toFileData(tmp1_safe_receiver);
        tmp_1.di2_1 = Signal().hak(tmp2_elvis_lhs == null ? emptyList() : tmp2_elvis_lhs);
        this.ei2_1 = Signal().hak(false);
        var tmp_2 = this;
        tmp_2.fi2_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj(debounce(this.ei2_1, 200n)));
        this.gi2_1 = new (SpecificationItemForm())(this.ci2_1, this.di2_1);
        var tmp_3 = this;
        tmp_3.hi2_1 = Action('Save', VOID, EditSpecificationItem$save$slambda_0(this));
      }
      vhn(_this__u8e3s4, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_remove__l4h01w.bind(VOID, this, _this__u8e3s4), $completion);
      }
      wd6(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        view.bb9(get_rem(0));
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.zbm(false);
        dynamicTheme(view_0, ($this$dynamicTheme) => $this$dynamicTheme.daj(this.ei2_1) ? WithoutPadding_instance : null);
        var tmp = view_0.kbb(view_0.kbb(get_expanding(view_0), get_expandButtonTheme(view_0)), get_unpadded(view_0));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (Button())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.gbb(p_2, view_2);
        view_2.zbm(false);
        view_2.lbb(get_centered(view_2), expandIcon(view_2, this.ei2_1));
        var tmp_0 = view_2.kbb(get_viewIsNarrow(view_2) ? get_expanding(view_2) : Companion_getInstance(), get_centered(view_2));
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (TextView())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.gbb(p_3, view_3);
        view_3.lba(view_3.qb6_1.abf(BodySemantic_getInstance()));
        var tmp_1 = KMutableProperty0();
        var tmp_2 = TextView$_get_content_$ref_4pzcwl(view_3);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('content', 0, tmp_1, tmp_2, TextView$_set_content_$ref_pketfb(view_3));
        reactiveScope(view_3, ($this$reactiveScope) => {
          // Inline function 'kotlin.text.ifBlank' call
          var this_1 = $this$reactiveScope.daj(this.gi2_1.yi2());
          var tmp;
          if (isBlank(this_1)) {
            tmp = 'New Specification';
          } else {
            tmp = this_1;
          }
          var tmp$ret$2 = tmp;
          this_0.set(tmp$ret$2);
          return Unit_instance;
        });
        view_2.hbb(p_3, view_3);
        view_2.lbb(tmp_0, view_3);
        if (get_viewIsWide(view_2)) {
          var tmp_3 = view_2.kbb(view_2.kbb(get_expanding(view_2), get_centered(view_2)), get_italic(view_2));
          // Inline function 'com.crowpay.views.theming.smallBody' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_4 = new (TextView())(view_2.pc());
          var tmp0_elvis_lhs_4 = view_2.ebb_1;
          var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
          view_2.gbb(p_4, view_4);
          view_4.lba(view_4.qb6_1.abf(SmallBodySemantic_getInstance()));
          var tmp_4 = KMutableProperty0();
          var tmp_5 = TextView$_get_content_$ref_4pzcwl_0(view_4);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_1 = getPropertyCallableRef('content', 0, tmp_4, tmp_5, TextView$_set_content_$ref_pketfb_0(view_4));
          reactiveScope(view_4, ($this$reactiveScope) => {
            var tmp$ret$9 = truncate($this$reactiveScope.daj(this.gi2_1.s91()), 50);
            this_1.set(tmp$ret$9);
            return Unit_instance;
          });
          view_2.hbb(p_4, view_4);
          view_2.lbb(tmp_3, view_4);
        }
        var tmp_6 = get_centered(view_2);
        // Inline function 'com.crowpay.views.theming.smallBody' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (TextView())(view_2.pc());
        var tmp0_elvis_lhs_5 = view_2.ebb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_2 : tmp0_elvis_lhs_5;
        view_2.gbb(p_5, view_5);
        view_5.lba(view_5.qb6_1.abf(SmallBodySemantic_getInstance()));
        shownDefaultFalse(view_5, ($this$shownDefaultFalse) => MonetaryValue__compareTo_impl_w7ul1r($this$shownDefaultFalse.daj(this.gi2_1.zi2()).y5r_1, Companion_instance.r91(0n)) > 0);
        var tmp_7 = KMutableProperty0();
        var tmp_8 = TextView$_get_content_$ref_4pzcwl_1(view_5);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_2 = getPropertyCallableRef('content', 0, tmp_7, tmp_8, TextView$_set_content_$ref_pketfb_1(view_5));
        reactiveScope(view_5, ($this$reactiveScope) => {
          var tmp$ret$16 = MonetaryValue__toString_impl_xslc77($this$reactiveScope.daj(this.gi2_1.zi2()).y5r_1);
          this_2.set(tmp$ret$16);
          return Unit_instance;
        });
        view_2.hbb(p_5, view_5);
        view_2.lbb(tmp_6, view_5);
        view_1.hbb(p_2, view_2);
        view_1.obg(expandAction(this.ei2_1));
        view_0.hbb(p_1, view_1);
        view_0.lbb(tmp, view_1);
        var tmp_9 = view_0.kbb(get_centered(view_0), get_deleteButton(view_0));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (Button())(view_0.pc());
        var tmp0_elvis_lhs_6 = view_0.ebb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_0 : tmp0_elvis_lhs_6;
        view_0.gbb(p_6, view_6);
        var tmp_10 = KMutableProperty0();
        var tmp_11 = Button$_get_visible_$ref_mav0jg(view_6);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_3 = getPropertyCallableRef('visible', 0, tmp_10, tmp_11, Button$_set_visible_$ref_7zj5sg(view_6));
        reactiveScope(view_6, ($this$reactiveScope) => {
          var tmp$ret$30 = $this$reactiveScope.daj(this.bi2_1);
          this_3.set(tmp$ret$30);
          return Unit_instance;
        });
        icon(view_6, get_trash(Companion_getInstance_0()), 'Remove Specification');
        onClick(view_6, VOID, VOID, EditSpecificationItem$render$slambda_0(this, view_6));
        view_0.hbb(p_6, view_6);
        view_0.lbb(tmp_9, view_6);
        view.hbb(p_0, view_0);
        var tmp_12 = shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.daj(this.ei2_1));
        // Inline function 'com.crowpay.views.components.indentedCol' call
        var indent = Indent_CenteredSection_getInstance();
        var tmp2 = indent.agr_1;
        // Inline function 'com.crowpay.views.components.indentedCol' call
        var afterSpace = indent.bgr_1;
        var tmp_13 = get_unpadded(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_7 = view.ebb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view : tmp0_elvis_lhs_7;
        view.gbb(p_7, view_7);
        var tmp_14;
        var tmp_15 = null;
        if (!((tmp_15 == null ? null : new (Dimension())(tmp_15)) == null)) {
          tmp_14 = sizeConstraints(view_7, VOID, VOID, VOID, VOID, VOID, null);
        } else {
          tmp_14 = Companion_getInstance();
        }
        var tmp_16 = view_7.kbb(tmp_14, indented(view_7, tmp2, afterSpace));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (RowOrCol())(view_7.pc());
        var tmp0_elvis_lhs_8 = view_7.ebb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
        view_7.gbb(p_8, view_8);
        view_8.zbm(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_9 = new (Space())(view_8.pc());
        var tmp0_elvis_lhs_9 = view_8.ebb_1;
        var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
        view_8.gbb(p_9, view_9);
        view_8.hbb(p_9, view_9);
        render(this.gi2_1, view_8);
        var tmp_17 = get_atEnd(view_8);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_10 = new (RowOrCol())(view_8.pc());
        var tmp0_elvis_lhs_10 = view_8.ebb_1;
        var p_10 = tmp0_elvis_lhs_10 == null ? view_8 : tmp0_elvis_lhs_10;
        view_8.gbb(p_10, view_10);
        view_10.zbm(false);
        view_10.bb9(get_AppDimensions().kg2_1);
        var tmp_18 = get_textButton(view_10);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_11 = new (Button())(view_10.pc());
        var tmp0_elvis_lhs_11 = view_10.ebb_1;
        var p_11 = tmp0_elvis_lhs_11 == null ? view_10 : tmp0_elvis_lhs_11;
        view_10.gbb(p_11, view_11);
        specCenteredText(view_11, 'Discard');
        onClick(view_11, VOID, VOID, EditSpecificationItem$render$slambda_2(this, view_11));
        view_10.hbb(p_11, view_11);
        view_10.lbb(tmp_18, view_11);
        var tmp_19 = view_10.kbb(get_primaryButton(view_10), align(view_10, Align_End_getInstance(), Align_Center_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_12 = new (Button())(view_10.pc());
        var tmp0_elvis_lhs_12 = view_10.ebb_1;
        var p_12 = tmp0_elvis_lhs_12 == null ? view_10 : tmp0_elvis_lhs_12;
        view_10.gbb(p_12, view_12);
        var tmp_20 = KMutableProperty0();
        var tmp_21 = Button$_get_enabled_$ref_61t7nx(view_12);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_4 = getPropertyCallableRef('enabled', 0, tmp_20, tmp_21, Button$_set_enabled_$ref_o8kynz(view_12));
        reactiveScope(view_12, ($this$reactiveScope) => {
          var tmp$ret$45 = $this$reactiveScope.daj(get_issues(this.ci2_1)).i1();
          this_4.set(tmp$ret$45);
          return Unit_instance;
        });
        specCenteredText(view_12, 'Save');
        view_12.obg(this.hi2_1);
        view_10.hbb(p_12, view_12);
        view_10.lbb(tmp_19, view_12);
        view_8.hbb(p_10, view_10);
        view_8.lbb(tmp_17, view_10);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_13 = new (Space())(view_8.pc());
        var tmp0_elvis_lhs_13 = view_8.ebb_1;
        var p_13 = tmp0_elvis_lhs_13 == null ? view_8 : tmp0_elvis_lhs_13;
        view_8.gbb(p_13, view_13);
        view_8.hbb(p_13, view_13);
        view_7.hbb(p_8, view_8);
        view_7.lbb(tmp_16, view_8);
        view.hbb(p_7, view_7);
        var tmp$ret$65 = view.lbb(tmp_13, view_7);
        view.lbb(tmp_12, tmp$ret$65);
        _this__u8e3s4.hbb(p, view);
        return view;
      }
    }
    protoOf($).wcv = get_title;
    initMetadataForClass($, 'EditSpecificationItem', VOID, VOID, [Page()], [1]);
    EditSpecificationItemClass = $;
  }
  return EditSpecificationItemClass;
}
//region block: exports
export {
  EditSpecificationItem as EditSpecificationItem2oupkkbghtex5,
};
//endregion

//# sourceMappingURL=EditSpecificationItem.mjs.map
